export const ZERO_WIDTH_SPACE = '​';
